// extracted by mini-css-extract-plugin
export var numpadContainer = "_pj-1";
export var phoneButton = "_pj-0";